<template>
  <v-app id="inspire" class="login">
    <v-content class="grey darken-1">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <router-view :key="$route.fullPath"></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer color="primary" app>
      <span
        class="white--text caption px-2"
        v-html="$vuetify.t('$vuetify.app.copyright')"
      ></span>
      <v-spacer></v-spacer>
      <v-icon dark @click="reloadApp()">refresh</v-icon>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoginLayout',
  components: {},
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  methods: {
    reloadApp() {
      window.location.reload()
    }
  }
}
</script>
